"use strict";

module.exports = {
    MODE_DATE: "date",
    MODE_DATETIME: "datetime",
    MODE_TIME: "time",

    SIZE_SMALL: "sm",
    SIZE_MEDIUM: "md",
    SIZE_LARGE: "lg"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-bootstrap-datetimepicker/lib/Constants.js
 ** module id = 485
 ** module chunks = 0
 **/